/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aci_CostsInputs */

const en_nav_aci_costs = /** @type {(inputs: Nav_Aci_CostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACI Costs`)
};

const es_nav_aci_costs = /** @type {(inputs: Nav_Aci_CostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costos ACI`)
};

/**
* | output |
* | --- |
* | "ACI Costs" |
*
* @param {Nav_Aci_CostsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aci_costs = /** @type {((inputs?: Nav_Aci_CostsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aci_CostsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_aci_costs(inputs)
	return es_nav_aci_costs(inputs)
});